// extracted by mini-css-extract-plugin
export default {"inline":"Common_inline__uycyr","fileBox":"Common_fileBox__ARN9i","reactQuillHover":"Common_reactQuillHover__yHQsx","wrap":"Common_wrap__XSbJJ"};